export enum SnDownloadStatus {
  Pending = 0,
  InProgress = 1,
  Completed = 2,
  Error = 3,
  Failed = 9,
}
